exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!../../assets/css/app.css"), "");

// module
exports.push([module.id, ".fade-enter-active,.fade-leave-active{transition-duration:.3s;transition-property:height,opacity;transition-timing-function:ease;overflow:hidden}.fade-enter,.fade-leave-active{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d963cbae","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ecosystems/App.vue
// module id = 87
// module chunks = 0